// SHIM — codice spostato in src/shared/msp/constants.js
export { default, sport_id } from '@shared/msp/constants.js';
